"use client";
import 'swiper/css';
import React from 'react';
import Image from 'next/image';
import { GlareCard } from '../ui/glare-card';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import AnimationContainer from "../utils/animation-container";

import apex from "@public/games/apex-icon.webp";
import game1 from "@public/games/arena-icon.webp";
import game2 from "@public/games/band-band-icon.webp";
import game3 from "@public/games/brawel-icon.webp";
import game4 from "@public/games/cod-mobile-home.webp";
import game5 from "@public/games/fortnite-home.webp";
import game6 from "@public/games/r6-icon.webp";
import game7 from "@public/games/cr-icon.webp";
import game8 from "@public/games/fallguys-icon.webp";
import game9 from "@public/games/ff-home.webp";
import game10 from "@public/games/gi-icon.webp";
import game11 from "@public/games/uc-home.webp";
import game12 from "@public/games/warzone-icon.webp";

const Games = () => {
  return (
    <div>
        <AnimationContainer delay={0.5}>
            <div className='mb-3 flex flex-col gap-2'>
                <h1 className="font-medium text-[24px]">بازی های پر طرفدار</h1>
                <p className='text-[13px] text-gray-400'>برترین عناوین گیمینگ که دنیای بازی‌ها را تسخیر کرده‌اند!</p>
            </div>
            <div className="w-full">
                <Swiper
                    loop={true}
                    grabCursor={true}
                    autoplay={{
                        delay: 2500,
                        pauseOnMouseEnter: true
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 4,
                            spaceBetween: 0,
                        },
                        640: {
                            slidesPerView: 6,
                            spaceBetween: 0,
                        },
                        768: {
                            slidesPerView: 9,
                            spaceBetween: 0,
                        },
                        1024: {
                            slidesPerView: 12,
                            spaceBetween: 0,
                        }
                    }}
                    modules={[Autoplay]}
                >
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={apex.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game1.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game2.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game3.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game4.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game5.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game6.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game7.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game8.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game9.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game10.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game11.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                    <SwiperSlide className="flex justify-center items-center">
                        <GlareCard padding={2} scale={1.12} className="transition-colors duration-200 rounded-md hover:bg-gray-200/5 bg-gradient-to-t from-[#ffffff11] to-transparent shadow-md flex justify-center items-center">
                            <Image src={game12.src} width={1024} height={1024} alt="Apex" className="object-contain" />
                        </GlareCard>
                    </SwiperSlide>
                </Swiper>
            </div>
        </AnimationContainer>
    </div>
  );
};

export default Games;
